/**
 * Used this component to added links or info into top right header
 * Mobile version: under social links
 */

import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import { Icon } from 'iovisit-theme/components';
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';

const messages = defineMessages({
  newsletter_subscribe: {
    id: 'newsletter_subscribe',
    defaultMessage: 'Iscriviti alla newsletter',
  },
});

const HeaderTopRightMore = () => {
  const intl = useIntl();
  const newsletterLink = config.settings.iovisit.subscribeNewsletterLink; // change link of subscribe here

  return newsletterLink ? (
    <span className="iv--newsletter-link">
      <UniversalLink href={newsletterLink}>
        <Icon prefix="far" icon="envelope" className="icon" />
        {intl.formatMessage(messages.newsletter_subscribe)}
      </UniversalLink>
    </span>
  ) : (
    <></>
  );
};

export default HeaderTopRightMore;
